<template>
  <div class="standard-page v-flex">
    <b-button-toolbar
      class="button-toolbar"
      aria-label="Toolbar with button groups"
    >
      <b-button><BIcon icon="funnel-fill" /> Filter</b-button>
      <b-button><BIcon icon="box-arrow-up-right" /> Edit</b-button>
    </b-button-toolbar>
    <Table
      class="standard-page-table"
      :fields="tableHeaders"
      :items="merchantAccounts"
      :busy="isBusy"
      :totalItems="totalMerchantAccounts"
      :totalPages="totalPages"
      :pageSize="pageSize"
      :currentPage="currentPage"
      @pageSizeChanged="handlePageSize"
      @pageChanged="handlePage"
    />
  </div>
</template>

<script>
import Table from '@/components/Table/Table.vue'
// import mockData from './mock-data.js'
import { BIcon } from 'bootstrap-vue'
import endpoints from '@/utils/endpoints.js'
import tableMixins from '@/mixins/TableMixins/tableMixins.js'

export default {
  mixins: [tableMixins],
  components: {
    Table,
    BIcon
  },
  data() {
    return {
      tableHeaders: [
        {
          link: true,
          key: 'propay_account_number',
          label: 'Propay Account Number'
        },
        'bank_name',
        'bank_account_type'
        /* TODO Merchant doesn't exist */
        // 'merchant'
      ],
      merchantAccounts: [],
      isBusy: true,
      totalMerchantAccounts: null,
      pageSize: 10,
      currentPage: 1,
      totalPages: null
    }
  },
  mounted() {
    this.getMerchantAccounts()
  },
  methods: {
    getMerchantAccounts() {
      this.axios
        .get(endpoints.listMerchantAccounts(this.$route.params.merchantID), {
          params: { page: this.currentPage, page_size: this.pageSize }
        })
        .then(res => {
          this.merchantAccounts = res.data.results
          this.isBusy = false
          this.totalMerchantAccounts = res.data.count
          this.totalPages = Math.ceil(
            this.totalMerchantAccounts / this.pageSize
          )
        })
        .catch(err => {
          console.log('error', err)
        })
    },
    handlePageSize(pageSize) {
      this.handlePageSizeChange(pageSize)
      this.getMerchantAccounts()
    },
    handlePage(newPage) {
      this.handlePageChange(newPage)
      this.getMerchantAccounts()
    }
  }
}
</script>
